<template>
  <el-container class="home_container">
    <!-- 头部区域 -->
    <el-header>
      <div>
        <img src="../assets/yhq.png" alt />
        <span>智慧停车商家管理后台</span>
      </div>
      <div>
        <el-button type="info" @click="logout">退出</el-button>
      </div>
    </el-header>
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapse? '64px' : '200px'">
        <div class="toggle-button" @click="toggleCollapse">|||</div>
        <el-menu background-color="#333744" text-color="#fff"
            active-text-color="#409eff" unique-opened :collapse='isCollapse'
            :collapse-transition='false' :router="true" :default-active="activePath">
          <!-- 一级菜单 -->
          <el-submenu :index="item.id + ''" v-for="item in menulist" :key="item.id">
            <!-- 一级菜单区域 -->
            <template slot="title">
              <!-- 图标 -->
              <i :class="iconsObj[item.id]"></i>
              <!-- 文字 -->
              <span>{{item.authName}}</span>
            </template>
            <!-- 二级菜单 -->
            <el-menu-item :index="'/' + subItem.path" v-for="subItem in item.children"
            :key="subItem.id" @click="saveNavState('/' + subItem.path)">
              <!-- 图标 -->
              <i :class="subIconsObj[subItem.id]"></i>
              <!-- 文字 -->
              <span>{{subItem.authName}}</span>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <!-- 右侧内容区域 -->
      <el-main>
          <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  data () {
    return {
      menulist: [],
      iconsObj: {
        125: 'el-icon-s-ticket',
        325: 'el-icon-s-shop',
        525: 'el-icon-bank-card'
      },
      subIconsObj: {
        110: 'el-icon-s-grid',
        112: 'el-icon-truck',
        114: 'el-icon-time',
        310: 'el-icon-s-platform',
        320: 'el-icon-s-tools',
        510: 'el-icon-document-add',
        520: 'el-icon-document-copy',
        530: 'el-icon-s-order',
        540: 'el-icon-s-data'
      },
      isCollapse: false,
      activePath: ''
    }
  },

  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
    this.getMenuInfo()
  },
  mounted () {

  },
  methods: {
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    // 获取菜单信息
    async getMenuInfo () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      const { data: res } = await this.$http.get('queryMerchantInfoByToken', { headers: { token: token } })
      // console.log(res)
      if (res.code === '0') {
        this.menulist = JSON.parse(res.data.menuJson)
        // console.log(this.menulist)
      } else {
        return this.$message.error(res.message)
      }
    },
    // 菜单的隐藏显示
    toggleCollapse () {
      this.isCollapse = !this.isCollapse
    },
    // 保存链接的激活状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    },
    // 修改密码的方法
    changePassword () {

    }
  }
}
</script>

<style lang="less" scoped>
.home_container {
  height: 100%;
}
.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  align-items: center;
  color: #fff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}
.el-aside {
  background-color: #333744;
  .el-menu{
      border-right: none;
  }
}
.el-main {
  background-color: #eaedf1;
}
.iconfont{
    margin-right: 10px;
}
.toggle-button{
    background-color: #4a5064;
    font-size: 10px;
    line-height: 24px;
    color: #fff;
    text-align: center;
    letter-spacing: 0.2em;
    cursor: pointer;
}
</style>
